import {ConditionBase} from "./ConditionBase";
import {Condition} from "../AdvancedSearchControls";
import * as React from "react";

export class NumberCondition extends ConditionBase{
    GetComparisons(): { Label: string; Value: string }[] {
        return [
            {Label:'Equal',Value:'='},
            {Label:'Not Equal',Value:'<>'},
            {Label:'Greater than',Value:'>'},
            {Label:'Greater or equal than',Value:'>='},
            {Label:'Less than',Value:'<'},
            {Label:'Less or equal than',Value:'<='}
        ];
    }

    GetValueEditor(condition: Condition, callback: () => void): React.ReactElement<any, string | React.JSXElementConstructor<any>> {
        return (
            <div className={'rncontrol'}>
                <label/>
                <input style={{width:'100%'}} type={'text'} value={condition.Value} onChange={x=>{condition.Value=x.target.value;callback();}} />
            </div>
        );
    }

}